import config from '@config/config';
import ApiService from './api';

class NoteApi extends ApiService {
  constructor() {
    if (NoteApi.instance) {
      return NoteApi.instance;
    }

    super(config.noteApiUrl);
    NoteApi.instance = this;
  }

  async getNotesByUserId(accountId, userId, customRolesId = '') {
    customRolesId = customRolesId ? customRolesId : '';
    const response = await this.http.get(`/accounts/${accountId}/notes?userId=${userId}&customRolesId=${customRolesId}`);
    return response.data;
  }

  async getLastNoteByUserId(accountId, userId, customRolesId = '') {
    customRolesId = customRolesId ? customRolesId : '';
    const response = await this.http.get(`/accounts/${accountId}/notes?userId=${userId}&last=true&customRolesId=${customRolesId}`);
    return response.data;
  }

  async getNoteById(accountId, noteId) {
    const response = await this.http.get(`/accounts/${accountId}/notes/${noteId}`);
    return response.data;
  }

  async createNote(accountId, data) {
    const response = await this.http.post(`/accounts/${accountId}/notes`, data);
    return response.data;
  }

  async updateNote(accountId, noteId, data) {
    const response = await this.http.put(`/accounts/${accountId}/notes/${noteId}`, data);
    return response.data;
  }

  async deleteNote(accountId, noteId) {
    const response = await this.http.delete(`/accounts/${accountId}/notes/${noteId}`);
    return response.data;
  }
}

const noteApiInstance = new NoteApi();
export default noteApiInstance;
